(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('travelBill', {
        templateUrl: 'views/components/views/travelBill/travelBill.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'travelBillService', 'economyService', 'typeaheadService', function ($stateParams, stateService, utilityService, modalService, translateService, travelBillService, economyService, typeaheadService) {
            
            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;
            let travelBillNo = $stateParams.travelbill_no;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                projectButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('projectmenu', { project_keyno: vm.model.edit.project_keyno }) }
                ],
                custactNoteButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('workdetails', { custact_no: vm.model.edit.custact_no }) }
                ],
                edit: {},
                selectListLabours: [],
                selectListProjects: [],
                selectListProjectProcesses: [],
                selectListSrResourcesFrom: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await travelBillService.getEdit({
                    argtype: argType,
                    argvalue: argValue,
                    travelbill_no: travelBillNo
                }))[0];
            }
            
            async function loadLabours() {
                vm.model.selectListLabours = await travelBillService.listLabours();
            }
            
            async function loadProjects() {
                if (utilityService.validateParmsValue(vm.model.edit.cust_no) !== true) return;
                
                vm.model.selectListProjects = await travelBillService.listProjects({ cust_no: vm.model.edit.cust_no });
            }
            
            async function loadProjectProcesses() {
                if (utilityService.validateParmsValue(vm.model.edit.project_keyno) !== true) return;
                
                vm.model.selectListProjectProcesses = await economyService.listProjectProcesses({
                    project_keyno: vm.model.edit.project_keyno,
                    show_only_timeentry_allowed: '1'
                });
            }
            
            async function loadTravelBillSrResourcesFroms() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                vm.model.selectListSrResourcesFrom = await travelBillService.loadTravelBillSrResourcesFromList(vm.model.edit.custact_no);
            }
            
            async function retrieveDietDaysInfo() {
                if (utilityService.validateParmsValue(vm.model.edit.start_dt) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.end_dt) !== true) return;
                
                const response = (await travelBillService.updateDietDaysInfo({
                    start_dt: vm.model.edit.start_dt,
                    end_dt: vm.model.edit.end_dt
                }))[0];

                vm.model.edit.diet_days = response.diet_days;
                vm.model.edit.diet_hours = response.diet_hours;
                vm.model.edit.nights = response.nights;
                vm.model.edit.nbr_of_days = response.nbr_of_days;
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'cust_name':
                        vm.model.edit[id] = value;

                        return typeaheadService.searchCustomer({
                            cust_name: vm.model.edit[id] || '',
                            filtertype: '',
                            filtervalue: '',
                            custtype: 'C',
                            lastselect: 'SEARCH'
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'cust_name':
                        if (item) {
                            vm.model.edit.cust_no = item?.item_id ?? '0';
                            vm.model.edit.cust_name = item?.item_name ?? '';
                            loadProjects();
                        } else {
                            vm.onTypeaheadClear('cust_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'cust_name':
                        vm.model.edit.cust_name = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.edit.cust_no = item.item_id;
                                loadProjects();
                            }
                        } else {
                            vm.onTypeaheadClear('cust_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'cust_name':
                        vm.model.edit.cust_no = '0';
                        vm.model.edit.cust_name = '';
                        vm.model.edit.project_keyno = '0';
                        vm.model.selectListProjects = [];
                        vm.model.selectListProjectProcesses = [];
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id, item) {
                switch (id) {
                    case 'project_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.edit.project_keyno) !== true) return;

                        vm.model.edit.project_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.edit.project_keyno, true) !== true) return;

                        loadProjectProcesses();
                        break;
                    case 'start_dt':
                    case 'end_dt':
                        if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                        vm.model.edit[id] = value;

                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                        retrieveDietDaysInfo();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                travelBillService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();

                if (vm.model.edit.sr === '0') loadLabours();

                loadProjects();
                loadProjectProcesses();
                loadTravelBillSrResourcesFroms();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
